module.exports = __webpack_public_path__ + "media/images/button-left-cee70884bbe7d6f3ea68894c3625b56e.svg";